<ng-container>
    <div class="select-projet-dialog__content">
        <p>Veuillez sélectionner le projet sur lequel vous voulez ajouter le poteau : </p>
        <p-dropdown class="dropdown" [options]="projetItems" [(ngModel)]="selectedProjet">
        </p-dropdown>
    </div>
    <div class="select-projet-dialog__footer">
        <button pButton type="button" label="OK" (click)="closeSelectProjetDialog()"></button>
    </div>
</ng-container>